function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import { InfoPanel } from "../components/info-panel";
import { Heading } from "../components/heading";
import JSONTree from "../components/json-tree";
import { List } from "../components/list";
import { SplitView, SplitViewCol } from "../components/split-view";
import { atom, useAtom, useAtomValue } from "jotai";
import { editorStateAtom } from "../state/editor-state";
export function valueRenderer(raw) {
  if (typeof (arguments.length <= 1 ? undefined : arguments[1]) === "function") {
    return "func";
  }
  return raw;
}
export function PluginState(props) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Heading, null, "Plugin State"), /*#__PURE__*/React.createElement(JSONTree, {
    data: props.pluginState,
    valueRenderer: valueRenderer
  }));
}
var selectedPluginIndexAtom = atom(0);

// TODO: replace isDimmed with useCallback once EditorStateContainer is decomposed
export default function PluginsTab() {
  var _useAtom = useAtom(selectedPluginIndexAtom),
    _useAtom2 = _slicedToArray(_useAtom, 2),
    selectedIndex = _useAtom2[0],
    setSelected = _useAtom2[1];
  var isSelected = React.useCallback(function (_plugin, index) {
    return selectedIndex === index;
  }, [selectedIndex]);
  var handleOnListItemClick = React.useCallback(function (_plugin, index) {
    return setSelected(index);
  }, []);
  var state = useAtomValue(editorStateAtom);
  if (!state) return null;
  var plugins = state.plugins;
  var selectedPlugin = plugins[selectedIndex];
  var selectedPluginState = selectedPlugin.getState(state);
  return /*#__PURE__*/React.createElement(SplitView, {
    testId: "__prosemirror_devtools_tabs_plugins__"
  }, /*#__PURE__*/React.createElement(SplitViewCol, {
    noPaddings: true
  }, /*#__PURE__*/React.createElement(List, {
    items: plugins,
    getKey: function getKey(plugin) {
      return plugin.key;
    },
    title: function title(plugin) {
      return plugin.key;
    },
    isSelected: isSelected,
    isDimmed: function isDimmed(plugin) {
      return !plugin.getState(state);
    },
    onListItemClick: handleOnListItemClick
  })), /*#__PURE__*/React.createElement(SplitViewCol, {
    grow: true,
    sep: true
  }, selectedPluginState ? /*#__PURE__*/React.createElement(PluginState, {
    pluginState: selectedPluginState
  }) : /*#__PURE__*/React.createElement(InfoPanel, null, "Plugin doesn't have any state")));
}